import { type ReactNode, useEffect, useRef } from 'react';

export default function ModerationDialog({
  title,
  children,
  comparison = false,
  onClose,
}: {
  title: string;
  children: ReactNode;
  comparison?: boolean;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    dialog?.showModal();
    return () => dialog?.close();
  }, []);
  return (
    <dialog
      ref={ref}
      className={`scs-moderation-dialog${comparison ? ' scs-moderation-dialog--comparison' : ''}`}
      aria-labelledby="scs-moderation-dialog-title"
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <div className="scs-moderation-dialog__header">
        <h2 id="scs-moderation-dialog-title" className="govuk-heading-m govuk-!-margin-bottom-0">
          {title}
        </h2>
        <button
          type="button"
          className="scs-moderation-dialog__close"
          aria-label="Close popup"
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {children}
    </dialog>
  );
}
